<router-outlet></router-outlet>


// WEBPACK FOOTER //
// /home/markush/Projects/fieldsale-wingman-client/src/app/app.component.ts.AppComponent.html